// removed by extract-text-webpack-plugin
module.exports = {"container":"_1vJYL","isLoading":"_1ka5G","image":"_3UZeM"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-image.scss
// module id = 748
// module chunks = 3 4 5 6 7